export default "<router-outlet (activate)='onActivate()'></router-outlet>\n<app-footer></app-footer>"